import Layout from "../components/Layout";
import { ResearchList } from "../components/Entries";
import { research } from "../content/writing";
import styles from "../styles/Site.module.css";

const Research = () => {
    return (
        <Layout>
            <h1 className={styles.pageTitle}>Research</h1>
            <p className={styles.intro}>
                Papers, preprints, and technical releases.
            </p>
            <ResearchList items={research} />
        </Layout>
    );
};

export default Research;
